export const faqData = [
    {
        question: "What is A1 Tutorial?",
        answer: "A1 Tutorial is a tutoring centre in Montreal, in the Parc-Extension neighbourhood, for elementary, high school and CEGEP students."
    },
    {
        question: "Do you offer tutoring in French, math and science?",
        answer: "Yes. The centre offers tutoring in French, mathematics and science, as well as homework help."
    },
    {
        question: "Do you offer homework help?",
        answer: "Yes. A1 Tutorial offers homework help in French, mathematics and science for elementary, high school and CEGEP students in Parc-Extension, Montreal."
    },
    {
        question: "Do you tutor elementary, high school and CEGEP students?",
        answer: "Yes. The centre welcomes elementary, high school and CEGEP students in Montreal, in the Parc-Extension neighbourhood."
    },
    {
        question: "Do you offer group tutoring and individual tutoring?",
        answer: "Yes. A1 Tutorial offers group tutoring and one-on-one tutoring in French, mathematics and science for elementary, high school and CEGEP students in Parc-Extension, Montreal."
    },
    {
        question: "Where is the centre located?",
        answer: "At 892 Jean-Talon West, Montreal, QC H3N 1S6, in Parc-Extension."
    },
    {
        question: "How do I register my child?",
        answer: "You can register on the admission page or call (514) 690-6696. The centre is at 892 Jean-Talon West, Montreal, QC H3N 1S6."
    },
    {
        question: "When is the centre open?",
        answer: "Monday, Tuesday and Thursday, 4:30 PM to 7:30 PM. Saturday and Sunday, 11:00 AM to 1:00 PM. Wednesday and Friday are closed."
    }
]
